import * as React from "react"
import { yupResolver } from "@hookform/resolvers/yup"
import { useForm } from "react-hook-form"
import { ContactFormInput, useCreateContactFormMutation } from "@graphql/generated"
import { stringRequiredMax, Validator, emailRequired } from "@utils/validation"
import InputField from "@components/FormFields/InputField"
import TextArea from "@components/FormFields/TextArea"
import { Container } from "@components/styles"
import Button from "@components/Button"
import { useState } from "react"
import { FormMessageProps } from "@components/FormMessage/types"
import FormMessage from "@components/FormMessage"
import { ContactFormProps } from "./types"
import {
    FormContainer, ContentWrapper, StyledForm, Wrapper, ButtonWrapper
} from "./styles"

const ContactForm: React.FC<ContactFormProps> = ({ content }) => {
    const [formMessage, setFormMessage] = useState<FormMessageProps | null>(null)
    const validationSchema = Validator({
        email: emailRequired(),
        name: stringRequiredMax(50),
        surname: stringRequiredMax(50),
        message: stringRequiredMax(1000)
    })

    const {
        register, handleSubmit, reset, formState: { errors }
    } = useForm({
        mode: "onBlur",
        resolver: yupResolver(validationSchema)
    })

    const [
        { fetching, error: mutationError }, CreateContactFormMutation
    ] = useCreateContactFormMutation()

    const onSubmit = async (formData: ContactFormInput) => {
        setFormMessage(null)

        CreateContactFormMutation({ data: formData }).then((result) => {
            if (result.data?.createContactForm?.data?.id) {
                reset()
                setFormMessage({
                    type: "success",
                    message: "Bedankt voor je bericht! We zullen binnenkort contact met je opnemen."
                })
            } else {
                setFormMessage({
                    type: "error",
                    message: "Er is een fout opgetreden, probeer het opnieuw."
                })
            }
        })
    }
    return <Wrapper>
        <Container>
            {content && <ContentWrapper dangerouslySetInnerHTML={{ __html: content }} />}
            <FormContainer>
                {formMessage && <FormMessage {...formMessage} />}
                <StyledForm onSubmit={handleSubmit(onSubmit)} noValidate>
                    <InputField
                        id="name"
                        type="text"
                        label="Naam"
                        required
                        {...register("name")}
                        error={errors.name?.message}
                    />
                    <InputField
                        id="surname"
                        type="text"
                        label="Achternaam"
                        required
                        {...register("surname")}
                        error={errors.surname?.message}
                    />
                    <InputField
                        id="email"
                        type="email"
                        label="E-mailadres"
                        {...register("email")}
                        required
                        error={errors.email?.message}
                    />
                    <TextArea
                        required
                        label="Bericht"
                        {...register("message")}
                        error={errors.message?.message}
                    />
                    <ButtonWrapper>
                        <Button color="red" type="submit">Verstuur</Button>
                    </ButtonWrapper>
                </StyledForm>
            </FormContainer>
        </Container>
    </Wrapper>
}

export default ContactForm
